import BaseEntity from '@/editor/entities/BaseEntity';
import { IPoint2d } from '@/editor/math/IPoint2d';
import { TGlobalStores } from '@/editor/stores';
import { EEntityType } from '@/editor/types';

export abstract class OperateAbstract<T extends EEntityType = EEntityType.Base> {
  checkedEntity: BaseEntity<T> | null | undefined = null;
  moving: boolean = false;

  constructor(protected _gs: TGlobalStores) {}

  startMove(_point: IPoint2d): boolean | void {}

  /** 方向键微移：按偏移量更新虚拟模型，不走吸附。只有支持微移的实体才实现 */
  moveByOffset(_offset: IPoint2d) {}

  abstract move(point: IPoint2d): void;
  abstract completeMove(point: IPoint2d): void;
  abstract clear(): void;
  abstract dispose(): void;
}
